import ImageGalleryControl from '../control/ImageGallery'

const ImageGallery = () => {
    const images = [
        {
            original: 'https://picsum.photos/id/1018/1000/600/',
            thumbnail: 'https://picsum.photos/id/1018/250/150/',
        },
        {
            original: 'https://picsum.photos/id/1015/1000/600/',
            thumbnail: 'https://picsum.photos/id/1015/250/150/',
        },
        {
            original: 'https://picsum.photos/id/1019/1000/600/',
            thumbnail: 'https://picsum.photos/id/1019/250/150/',
        },
    ]

    return (
        <ImageGalleryControl
            data={images}
            sxProps={{
                width: {
                    xs: 100, // theme.breakpoints.up('xs')
                    sm: 300, // theme.breakpoints.up('sm')
                    md: 600, // theme.breakpoints.up('md')
                    lg: 800, // theme.breakpoints.up('lg')
                    xl: 1000, // theme.breakpoints.up('xl')
                },
            }}
            gridSize={{
                xs: 12,
            }}
        />
    )
}

export default ImageGallery
